import Image from 'next/image'
import React from 'react'
import Anton from '#/assets/images/car/anton-large.jpg'
import Quote from '#/assets/images/car/quote.svg'

export default function CeoBanner() {
  return (
    <div className='relative overflow-hidden shadow-xl'>
      <div className='flex'>
        <div
          className='z-10 ml-auto flex w-full flex-col items-center'
          style={{
            background:
              'linear-gradient(111deg, rgba(2,0,36,1) 0%, rgba(0,0,0,0.9878326330532213) 61%, rgba(10,10,10,0.02984943977591037) 74%, rgba(255,255,255,0) 100%)'
          }}
        >
          <div className='ml-8 mr-auto max-w-xs py-12 pr-16 text-sm font-thin text-white sm:max-w-md sm:py-24 sm:pr-0 sm:text-2xl md:ml-16 md:text-2xl lg:ml-28 xl:max-w-2xl xl:py-24 xl:text-3xl'>
            <Quote className='absolute h-4 w-4 -translate-x-5 text-white' />
            <span className='italic sm:leading-tight'>
              This platform is so powerful, that after 18 years in real estate,
              I wouldn&apos;t buy or sell a property without it!
            </span>
            <Quote className='absolute h-4 w-4 translate-x-3 translate-y-1 rotate-180 text-white' />

            <div className='mt-3 text-sm text-white sm:mt-8 sm:text-xl'>
              Anton Danilovich
            </div>
            <div className='text-xs text-white sm:text-lg'>TopHap CEO</div>
          </div>
        </div>
        <div className='absolute right-0 -mr-24 w-10/12 text-white sm:-mr-28 sm:w-11/12 md:-mr-32 md:w-8/12 xl:-mr-0 xl:w-5/12 '>
          <Image
            alt='Anton'
            src={Anton}
          />
        </div>
      </div>
    </div>
  )
}
